import { BCMSDefaultModel, BCMSStateManagerCRUD, BCMSRecord, useBCMSContext } from "bcms-react";
import Classes from "model";
import SettingsFastBalancesPage, { getDefaultPageData, getDefaultPageUI } from "components/pages/SettingsFastBalancesPage";
import "./styles.css";

export default function CaptureFastBalances(props) {
    const context = useBCMSContext();
    BCMSRecord.globalControllerFor(Classes, context);
    const mobileDevice = BCMSDefaultModel.mobileDevice();
    mobileDevice.name = "";
    mobileDevice.isEnrolled = false;

    const data = BCMSStateManagerCRUD.init(getDefaultPageData())
        .update([ "mobileDevice" ], mobileDevice)
        .submit();

    return <div className="fast-balances-005"><SettingsFastBalancesPage data={ data } /></div>;
}